export default __webpack_public_path__ + "static/media/Bg.601e23a7.jpg";